import { View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { AccountReferralHistory } from "@/containers/profile/account-my-referral/account-my-referral-history-component";
import { SortEnum, ClientReferralSortByEnum } from "@/__generated__/graphql";

export function ReferralSectionHistory() {
  return (
    <View className="mt-4.5 px-4 py-3">
      <View className="flex flex-col items-start gap-4">
        <Typography variant="label-md" color="foreground-default">
          Referral History
        </Typography>
      </View>
      <AccountReferralHistory
        filter={{
          limit: 4,
          sort: [SortEnum.Desc],
          sortBy: [ClientReferralSortByEnum.UpdatedAt],
        }}
      />
    </View>
  );
}
